module.exports = __webpack_public_path__ + "img/s23.204e0b71.png";